import { defineWidgetCore } from "../../widgetDefinition";
import type { ScatterplotComponentSpec } from "../../Processing/types";
import { buildScatterplotOptions } from "../../WidgetComponents/buildScatterplotOptions";
import { renderScatterplot } from "../../PDF/renderers/scatterplotPdfRenderer";
import { resolveTemplate } from "../../Utils/resolveTemplate";

export const scatterplotCore = defineWidgetCore<ScatterplotComponentSpec>({
  process(spec, response) {
    // "type" in … narrows past BodyMapNonSeriesResponse, which carries no
    // discriminant and otherwise blocks union narrowing on `.type`.
    const nonSeries = response?.non_series_response;
    const data =
      nonSeries && "type" in nonSeries && nonSeries.type === "scatterplot" ? nonSeries : null;
    return {
      type: "scatterplot",
      spec,
      scatterplot: {
        chartOptions: buildScatterplotOptions(spec, data),
        pointCount: data?.points.length ?? 0,
        droppedUnpaired: data?.dropped_unpaired ?? 0,
      },
    };
  },
  pdf: {
    capture: "highcharts",
    buildSnapshot({ processed, slicerValues }) {
      if (processed.type !== "scatterplot") return null;
      const rawTitle = processed.spec.display.title || null;
      return {
        type: "scatterplot",
        title: rawTitle == null ? null : resolveTemplate(rawTitle, slicerValues).resolved,
        summary: null,
      };
    },
    render({ id, snapshot, rect, scale, chartImages }) {
      if (snapshot.type !== "scatterplot") return null;
      return renderScatterplot(snapshot, rect, scale, chartImages[id]);
    },
  },
});
